

app.controller('CIF-CTRL', function ($scope, $rootScope, $routeParams, uibDateParser, $uibModal, $http, $window, $location, $timeout, Upload, $q, $filter) {

    $scope.CIFInvestor = {
        FirstName: '',
        Sex: '',
        Religion: '',
        MaritalStatus: '',
        Education: '',
        MobilePhone: ''
    }

    $scope.maxDate = new Date().toISOString().slice(0, 10);
    $scope.Kewarganegaraan = 'WNI / Indonesian';
    $scope.KewarganegaraanOption = ['WNI / Indonesian', 'Lainnya / Others'];
    $scope.IDLength = 16;
    $scope.chkSeumurHidup = true;
    $scope.DisabledSeumurHidup = true;
    $scope.tempBirthDate = '';

    $scope.IDCardCitySelected = '';
    $scope.DomicileCitySelected = '';
    $scope.NationalitySelected = '';
    $scope.IDCardCountrySelected = '';
    $scope.IDCardKecamatanSelected = '';

    $scope.ListNationality = [];
    $scope.ListLookup = [];
    $scope.ListReligion = [];
    $scope.ListMarital = [];
    $scope.ListEducation = [];
    $scope.ListKecamatan = [];
    $scope.ListKecamatanDomicile = [];
    $scope.ListKecamatanAll = [];
    $scope.ListKelurahan = [];
    $scope.ListKelurahanDomicile = [];

    $scope.checkIDCardNumber = function () {
        if ($scope.CIFInvestor.IDCardNumber || $scope.CIFInvestor.QuestionRDN) {
            $http({
                method: 'GET',
                url: '/service/client.svc/checkIDCardNumber?KTP=' + $scope.CIFInvestor.IDCardNumber + '&QuestionRDN=' + $scope.CIFInvestor.QuestionRDN,
                cache: false
            }).then(function (data) {
                if (data.data.d != null) {
                    var obj = data.data.d;
                    if (obj.key && obj.key == 1) {
                        $scope.CIFInvestor.IDCardNumber = '';
                        Swal.fire('Gagal', obj.value, "error");
                    }
                }
            }, function (error) { });
        }
    }


    $scope.KewarganegaraanChange = function () {
        if ($scope.Kewarganegaraan == 'WNI / Indonesian') {
            $scope.IDLength = 16;
            $scope.chkSeumurHidup = true;
            $scope.DisabledSeumurHidup = true;
            $scope.CIFInvestor.Nationality = 102;
            $scope.CIFInvestor.IDCardCountry = 102;
            $scope.CIFInvestor.CopyID = true;
            $scope.CIFInvestor.IDCardExpireDate = new Date(9998, 11, 31);
        }
        else if ($scope.Kewarganegaraan == 'Lainnya / Others') {
            $scope.IDLength = 8;
            $scope.chkSeumurHidup = false;
            $scope.DisabledSeumurHidup = true;
            $scope.CIFInvestor.Nationality = 0;
            $scope.CIFInvestor.IDCardCountry = 0;
            $scope.CIFInvestor.CopyID = false;
            $scope.CIFInvestor.IDCardExpireDate = '';
            $scope.CIFInvestor.IDCardCity = 0;
            $scope.CIFInvestor.IDCardKecamatan = '';
            $scope.CIFInvestor.IDCardKelurahan = '';
            $scope.CIFInvestor.IDCardRT = '';
            $scope.CIFInvestor.IDCardRW = '';
            $scope.CIFInvestor.IDCardAddress = '';
            $scope.IDCardCitySelected = '';
        }
    };

    $scope.test = function () {
        console.log('birthdate', $scope.CIFInvestor.BirthDate);
        var date1 = $filter('date')(new Date($scope.CIFInvestor.BirthDate), 'yyyy-MM-dd');
        console.log('birth2', date1);
    };


    $scope.selectNationality = function (item, model, label, event) {
        if (item.CIFCountryNID) {
            $scope.CIFInvestor.Nationality = item.CIFCountryNID;
            $scope.CIFInvestor.IDCardCountry = item.CIFCountryNID;
            $scope.NationalitySelected = item;
            $scope.IDCardCountrySelected = item;
        }

    };

    $scope.selectIDCardCountry = function (item, model, label, event) {
        if (item.CIFCountryNID) {
            $scope.CIFInvestor.IDCardCountry = item.CIFCountryNID;
        }
    };

    $scope.selectIDCardCity = function (item, model, label, event) {
        $scope.ListKecamatan = '';
        $scope.ListKelurahan = '';

        if (item.CIFProvinceCityNID) {
            $scope.CIFInvestor.IDCardCity = item.CIFProvinceCityNID;

            console.log('city', item.CIFProvinceCityNID);

            $http({
                method: 'GET',
                url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                cache: true,
            }).then(function (data) {
                $scope.ListKecamatan = data.data.d;
                $scope.kecamatanChange();
            }, function (error) { });
        }
    };

    $scope.selectDomicileCity = function (item, model, label, event) {
        $scope.ListKecamatanDomicile = '';
        $scope.ListKelurahanDomicile = '';

        if (item.CIFProvinceCityNID) {
            $scope.CIFInvestor.DomicileCity = item.CIFProvinceCityNID;

            $http({
                method: 'GET',
                url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                cache: true,
            }).then(function (data) {
                $scope.ListKecamatanDomicile = data.data.d;
                $scope.kecamatanChange();
            }, function (error) { });
        }

    };

    $scope.religiChange = function () {
        console.log('religichange', $scope.CIFInvestor.Religion);
    }

    $scope.kecamatanChange = function () {
        if ($scope.CIFInvestor.IDCardKecamatan) {
            $scope.ListKelurahan = $filter('filter')($scope.ListKecamatan, { Kecamatan: $scope.CIFInvestor.IDCardKecamatan }, true);
        }
    }

    $scope.kelurahanChange = function () {
        if ($scope.CIFInvestor.IDCardKelurahan) {
            let temp = $filter('filter')($scope.ListKecamatan, { Kelurahan: $scope.CIFInvestor.IDCardKelurahan }, true);
            if (temp) {
                $scope.CIFInvestor.IDCardPostalCode = temp[0].PostalCode;
            }
        }
    }

    $scope.kecamatanDomicileChange = function () {
        if ($scope.CIFInvestor.DomicileKecamatan) {
            $scope.ListKelurahanDomicile = $filter('filter')($scope.ListKecamatanDomicile, { Kecamatan: $scope.CIFInvestor.DomicileKecamatan }, true);
        }
    }

    $scope.kelurahanDomicileChange = function () {
        if ($scope.CIFInvestor.DomicileKelurahan) {
            let temp = $filter('filter')($scope.ListKecamatanDomicile, { Kelurahan: $scope.CIFInvestor.DomicileKelurahan }, true);
            if (temp) {
                $scope.CIFInvestor.DomicilePostalCode = temp[0].PostalCode;
            }
        }
    }

    $scope.CopyFromID = function () {
        if ($scope.CIFInvestor.CopyID) {

            if($scope.CIFInvestor.IDCardKecamatan)
            {
                let temp = $filter('filter')($scope.ListKecamatan, { Kecamatan: $scope.CIFInvestor.IDCardKecamatan }, true)[0];
                console.log('domisili', temp);
            }

            $scope.CIFInvestor.DomicilePostalCode = $scope.CIFInvestor.IDCardPostalCode;
            $scope.CIFInvestor.DomicileAddress = $scope.CIFInvestor.IDCardAddress;
            $scope.CIFInvestor.DomicileRT = $scope.CIFInvestor.IDCardRT;
            $scope.CIFInvestor.DomicileRW = $scope.CIFInvestor.IDCardRW;
            $scope.CIFInvestor.DomicileKelurahan = $scope.CIFInvestor.IDCardKelurahan;
            $scope.CIFInvestor.DomicileKecamatan = $scope.CIFInvestor.IDCardKecamatan;
            $scope.CIFInvestor.DomicileCity = $scope.CIFInvestor.IDCardCity;
            $scope.DomicileCitySelected = $scope.IDCardCitySelected;
        }
        else {
            $scope.CIFInvestor.DomicilePostalCode = '';
            $scope.CIFInvestor.DomicileAddress = '';
            $scope.CIFInvestor.DomicileRT = '';
            $scope.CIFInvestor.DomicileRW = '';
            $scope.CIFInvestor.DomicileKelurahan = '';
            $scope.CIFInvestor.DomicileKecamatan = '';
            $scope.CIFInvestor.DomicileCity = 0;
            $scope.DomicileCitySelected = '';
        }

    };

    $scope.mustSelect = function (event, field) {
        if (event.keyCode == 27) {
            let returnValue = true;
            switch (field) {
                case 'IDCard': $scope.CIFInvestor.IDCardCity = ''; returnValue = false;
                    break;
                case 'Domicile': $scope.CIFInvestor.DomicileCity = ''; returnValue = false;
                    break;
                case 'Correspondence': $scope.CIFInvestor.CorrespondenceCity = ''; returnValue = false;
                    break;
                default:
                    break;
            }
            return returnValue;
        }
        return true;
    }



    var allPromise = $q.all([
        $http({
            method: 'POST',
            url: '/service/client.svc/retrieveSession',
        }).then(function (data) {
            if (!data.data.d) {
                $http({
                    method: 'GET',
                    url: '/service/client.svc/SignOut',
                }).then(function (data) {
                    if (data.data.d == true) {
                        $window.location.href = "#/login";
                        $window.location.reload();
                    }
                }, function (error) { })
            }
            else
                $scope.currentUser = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFCountry',
            cache: true,
        }).then(function (data) {
            $scope.ListNationality = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFCountryAll',
            cache: true,
        }).then(function (data) {
            $scope.ListCountry = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFProvinceCity',
            cache: true,
        }).then(function (data) {
            $scope.ListProvinceCity = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFLookup',
            cache: true,
        }).then(function (data) {
            $scope.ListLookup = data.data.d;
            if ($scope.ListLookup) {
                $scope.ListReligion = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Religion' }, true);
                $scope.ListMarital = $filter('filter')($scope.ListLookup, { CIFLookupID: 'MaritalStatus' }, true);
                $scope.ListEducation = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Educational' }, true);
            }
        }, function (error) { }),

    ]);



    allPromise.then(function () {
        $http({
            method: 'GET',
            url: '/service/client.svc/getCIF',
        }).then(function (data) {
            if (data.data.d != null) {
                var obj = data.data.d;
                $scope.CIFInvestor = data.data.d;
                $scope.CIFInvestor.Stage = 1;

                if ($scope.CIFInvestor.Sex == 0)
                    $scope.CIFInvestor.Sex = '';

                if ($scope.CIFInvestor.Religion == 0)
                    $scope.CIFInvestor.Religion = '';

                if ($scope.CIFInvestor.MaritalStatus == 0)
                    $scope.CIFInvestor.MaritalStatus = '';

                if ($scope.CIFInvestor.Education == 0)
                    $scope.CIFInvestor.Education = '';

                if (data.data.d.BirthDate)
                    $scope.CIFInvestor.BirthDate = new Date(data.data.d.BirthDate);



                if (data.data.d.IDCardCity) {
                    $scope.IDCardCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.IDCardCity }, true)[0];
                    $http({
                        method: 'GET',
                        url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + data.data.d.IDCardCity,
                        cache: true,
                    }).then(function (dataKecamatan) {
                        $scope.ListKecamatan = dataKecamatan.data.d;
                        if ($scope.ListKecamatan)
                            $scope.ListKelurahan = $filter('filter')($scope.ListKecamatan, { Kecamatan: $scope.CIFInvestor.IDCardKecamatan }, true);
                    }, function (error) { });
                }



                if (data.data.d.DomicileCity) {
                    $scope.DomicileCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.DomicileCity }, true)[0];
                    $http({
                        method: 'GET',
                        url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + data.data.d.DomicileCity,
                        cache: true,
                    }).then(function (dataKecamatanDomisili) {
                        $scope.ListKecamatanDomicile = dataKecamatanDomisili.data.d;
                        if ($scope.ListKecamatanDomicile)
                            $scope.ListKelurahanDomicile = $filter('filter')($scope.ListKecamatanDomicile, { Kecamatan: $scope.CIFInvestor.DomicileKecamatan }, true);
                    }, function (error) { });
                }




                if (data.data.d.Nationality) {
                    if (data.data.d.Nationality == 102) {
                        $scope.IDLength = 16;
                        $scope.chkSeumurHidup = true;
                        $scope.DisabledSeumurHidup = true;
                        $scope.CIFInvestor.Nationality = 102;
                        $scope.CIFInvestor.IDCardCountry = 102;
                        $scope.Kewarganegaraan = $scope.KewarganegaraanOption[0];
                        $scope.CIFInvestor.IDCardExpireDate = new Date(9998, 11, 31);
                    }
                    else {
                        $scope.IDLength = 8;
                        $scope.chkSeumurHidup = false;
                        $scope.DisabledSeumurHidup = true;
                        $scope.Kewarganegaraan = $scope.KewarganegaraanOption[1];
                        $scope.NationalitySelected = $filter('filter')($scope.ListNationality, { CIFCountryNID: data.data.d.Nationality }, true)[0];
                        $scope.IDCardCountrySelected = $filter('filter')($scope.ListCountry, { CIFCountryNID: data.data.d.IDCardCountry }, true)[0];

                        if (data.data.d.IDCardExpireDate)
                            $scope.CIFInvestor.IDCardExpireDate = new Date(data.data.d.IDCardExpireDate);
                    }
                }
                else
                    $scope.KewarganegaraanChange();

                if (data.data.d.CopyID)
                    $scope.CopyFromID();

              

                swal({
                    title: 'Push notifications',
                    text: 'Mohon untuk memeriksa kembali dan melengkapi data diri anda',
                    imageUrl: 'img/erdikha/from_erdikha/LoginSelamatDatang.png',
                    imageAlt: 'E-KTP',
                    width: '400px',
                    animation: false
                });


            } // END IF data.data.d
        }, function (error) { });
    });

    $scope.prepareData = function () {
        if ($scope.CIFInvestor.CopyID) {
            $scope.CIFInvestor.DomicilePostalCode = $scope.CIFInvestor.IDCardPostalCode;
            $scope.CIFInvestor.DomicileAddress = $scope.CIFInvestor.IDCardAddress;
            $scope.CIFInvestor.DomicileRT = $scope.CIFInvestor.IDCardRT;
            $scope.CIFInvestor.DomicileRW = $scope.CIFInvestor.IDCardRW;
            $scope.CIFInvestor.DomicileKelurahan = $scope.CIFInvestor.IDCardKelurahan;
            $scope.CIFInvestor.DomicileKecamatan = $scope.CIFInvestor.IDCardKecamatan;
            $scope.CIFInvestor.DomicileCity = $scope.CIFInvestor.IDCardCity;
            $scope.DomicileCitySelected = $scope.IDCardCitySelected;
        }

        if ($scope.CIFInvestor.AccountStatus)
            $scope.CIFInvestor.AccountStatus = Number($scope.CIFInvestor.AccountStatus);

        if ($scope.CIFInvestor.Sex)
            $scope.CIFInvestor.Sex = Number($scope.CIFInvestor.Sex);

        if ($scope.CIFInvestor.Religion)
            $scope.CIFInvestor.Religion = Number($scope.CIFInvestor.Religion);

        if ($scope.CIFInvestor.Education)
            $scope.CIFInvestor.Education = Number($scope.CIFInvestor.Education);

        if ($scope.CIFInvestor.MaritalStatus)
            $scope.CIFInvestor.MaritalStatus = Number($scope.CIFInvestor.MaritalStatus);

        if ($scope.CIFInvestor.Nationality)
            $scope.CIFInvestor.Nationality = Number($scope.CIFInvestor.Nationality);

        if ($scope.CIFInvestor.IDCardCountry)
            $scope.CIFInvestor.IDCardCountry = Number($scope.CIFInvestor.IDCardCountry);

        if ($scope.CIFInvestor.IDCardCity)
            $scope.CIFInvestor.IDCardCity = Number($scope.CIFInvestor.IDCardCity);

        if ($scope.CIFInvestor.DomicileCity)
            $scope.CIFInvestor.DomicileCity = Number($scope.CIFInvestor.DomicileCity);

        var language;
        if (window.navigator.languages) {
            language = window.navigator.languages[0];
        } else {
            language = window.navigator.userLanguage || window.navigator.language;
        }
        $scope.CIFInvestor.language = language;

        if ($scope.CIFInvestor.BirthDate) {
            //var date1 = $filter('date')(new Date($scope.CIFInvestor.BirthDate), 'yyyy-MM-dd');
            //$scope.CIFInvestor.ClientBirthDate1 = $scope.CIFInvestor.BirthDate.toLocaleDateString('en-US');
            //$scope.CIFInvestor.ClientBirthDate2 = $scope.CIFInvestor.BirthDate;
            //$scope.CIFInvestor.ClientBirthDate3 = date1;

            //$scope.CIFInvestor.BirthDate = date1;

            $scope.CIFInvestor.BirthDate = moment($scope.CIFInvestor.BirthDate).format('YYYY-MM-DD');
            $scope.CIFInvestor.ClientBirthDate1 = moment($scope.CIFInvestor.BirthDate).format('YYYY-MM-DD');
            $scope.CIFInvestor.ClientBirthDate2 = moment($scope.CIFInvestor.BirthDate).format('YYYY-MM-DD');
            $scope.CIFInvestor.ClientBirthDate3 = moment($scope.CIFInvestor.BirthDate).format('YYYY-MM-DD');
        }

    }

    $scope.submit = function () {
        $scope.prepareData();
        var finished = 0;

        $scope.working = true;

        $rootScope.AlertYesNo('question', 'Konfirmasi', "Apakah data yang diisi sudah sesuai?")
        .then((result) => {
            if (result.value) {
                $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
                $http({
                    method: 'POST',
                    url: '/service/client.svc/SaveCIF',
                    data:
                        {
                            cifdata: $scope.CIFInvestor
                        },
                }).then(function (data) {

                    if (data.data.d.result) {
                        swal.close();
                        $window.location.href = "#/cif/data-pekerjaan";
                    }
                    else {
                        swal('Failed', data.data.d.message, 'error');
                    }
                }, function (error) {
                    swal('Error', 'error - Please check your connection', 'error');
                });
            }
        });

    }

    $scope.logOff = function () {
        $http({
            method: 'POST',
            url: '/service/client.svc/logOff',
        }).then(function (data) {
            console.log(data);
            if (data.data.d == true) {
                $window.location.href = "#/login";
                $window.location.reload();
            }
        }, function (error) { })
    };

    $scope.print = function () {
        $scope.prepareData();
    }

});